<template>
  <div>
    <div class="entete border-entete">
      <div class="is-paddingless section">
        <div class="level">
          <div class="level-left">
            <div class="columns is-gapless">
              <div class="column">
                <h1 class="title is-size-3" >
                  {{ detailLot.libelle }}
                </h1>
                <app-breadcrumb :breadcrumb="breadcrumb"/>
              </div>
            </div>
          </div>
          <a ref="lienDownload"></a>
          <div class="level-right">
            <dropdownButton
              type="is-addOrEdit"
              class="mgr-2"
              :actions="actionSecondary"
              @click="() => {
                $router.push(transfere(false));
              }">
                {{ $t('listeDetailLotsComptable.actions.transfere') }}
            </dropdownButton>
          </div>
        </div>
      </div>
    </div>
    <error-msg-component :messages="messages"
                         class="mgt-20px"
                         :error="error"
                         :title="'general.problemOccurred'"
                         :withEmplyFields="true"
                         @close="error = $event"/>
    <div class="steps-detail mgt-20px" v-if="curentStep">
      <dot-steps :steps="dataStep"
                  :current-step="curentStep"
                  :racineTraduction="''"/>
    </div>
    <div>
      <div class="card">
        <header class="header-card">
          <p>
            {{ $t('listeDetailLotsComptable.information.title')}}
          </p>
        </header>
        <div class="card-content">
          <div class="columns is-multiline">
            <div class="column is-4">
              <b-field :label="$t('listeDetailLotsComptable.information.nbEcritures')"
                       custom-class="has-text-weight-normal is-italic is-marginless">
                <span class="has-text-weight-bold"> {{ listeEcriture.length }} </span>
              </b-field>
            </div>
            <div class="column is-4">
              <b-field :label="$t('listeDetailLotsComptable.information.dateTransfert')"
                       custom-class="has-text-weight-normal is-italic is-marginless">
                <span class="has-text-weight-bold">{{detailLot.dateTransfert | formatDate }}</span>
              </b-field>
            </div>
            <div class="column is-4">
              <b-field :label="$t('listeDetailLotsComptable.information.montant')"
                       custom-class="has-text-weight-normal is-italic is-marginless">
                <span class="has-text-weight-bold">{{ getMontant | formatDevise }}</span>
              </b-field>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="columns mgt-10px">
      <form @submit.prevent="recherche()" class="column is-2">
        <b-field>
          <b-input :placeholder="$t('listeDetailLotsComptable.actions.search')"
                   type="search" icon="magnify"
                   v-model="search">
          </b-input>
        </b-field>
      </form>
    </div>
    <v-client-table :data="listeEcriture"
                    :columns="columns"
                    :options="options"
                    class='tableWithChildRow childrowEcheancierPaiement'>
      <div slot="dateComptable" slot-scope="props">
        {{ props.row.dateComptable | formatDate }}
      </div>
      <div slot="lot">
        {{ detailLot.libelle }}
      </div>
      <div slot="isValid" slot-scope="props">
        <span v-if="props.row.isValid">
          {{$t('listeDetailLotsComptable.etat.valide')}}
        </span>
        <span v-else>
          {{$t('listeDetailLotsComptable.etat.nonValide')}}
        </span>
      </div>
      <div slot="visu" slot-scope="props" class="has-text-centered">
        <router-link-blank
          :to="goPage(props.row)"
          class="lien"
          :icon="'file-find'">
        </router-link-blank>
      </div>
    </v-client-table>
    <b-modal v-model="openPopUpAnnulation"
      has-modal-card
      class="modal">
      <pop-up-prevention
        :messHeader="$t('listeDetailLotsComptable.annulationTransfert.title')"
        :msgAvertissements="[{ message: 'listeDetailLotsComptable.annulationTransfert.warning' }]"
        :cancel="$t('general.non')"
        :validate="$t('general.oui')"
        @no="openPopUpAnnulation = false"
        @yes="annulerTransfert"/>
    </b-modal>
  </div>
</template>

<script>

import cloneDeep from 'lodash/cloneDeep';
import breadcrumb from '@/components/general/breadcrumb';
import dropdownButton from '@/components/general/button/dropdownButton';
import messageSucces from '@/services/general/messageSucces';
import messageErreur from '@/services/general/messageErreur';
import {
  TEXTS, RESULTS_PER_PAGE, NO_PER_PAGE_VALUE, SORT_ICON,
} from '@/configuration/clientTableConf';
import { get, annulerTransmission } from '@/api/compta/ifLot/index';
import { transfere } from '@/api/compta/lot/index';
import Ecriture from '@/components/commun/ecritureComptable/ecritureCompta';
import DotSteps from '@/components/general/dotSteps';
import { LISTE_ETAT, TRANSMIS } from '@/configuration/compta/lotConf';
import { TYPE_VENTE, TYPE_REGLEMENT, TYPE_OD } from '@/configuration/compta/ecritureConf';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import validation from '@/services/compta/lot/validation';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import popUpPrevention from '@/components/general/popUpPrevention';

export default {
  data() {
    return {
      showFiltre: false,
      detailLot: {},
      listeEcriture: [],
      listeEtat: LISTE_ETAT,
      search: '',
      error: false,
      messages: [],
      openPopUpAnnulation: false,
    };
  },
  computed: {
    breadcrumb() {
      const output = [
        { title: this.$i18n.t('listeLotsComptable.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('listeLotsComptable.title'), route: { name: 'l.comptabilite.lots_comptable' }, isActive: false },
        { title: this.$i18n.t('listeDetailLotsComptable.title'), route: '', isActive: true },
      ];
      return output;
    },
    actionSecondary() {
      const actions = [
        {
          label: this.$t('listeDetailLotsComptable.actions.transfereTasser'),
          action: () => { this.transfere(true); },
        },
      ];
      if (this.detailLot.etat === TRANSMIS) {
        actions.push({
          label: this.$t('listeDetailLotsComptable.actions.annulerTransfert'),
          action: () => { this.openPopUpAnnulation = true; },
        });
      }
      return actions;
    },
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      return {
        sortIcon: SORT_ICON,
        headings: {
          dateComptable: this.$t('listeDetailLotsComptable.tab.date'),
          libelle: this.$t('listeDetailLotsComptable.tab.libelle'),
          journal: this.$t('listeDetailLotsComptable.tab.journal'),
          isValid: this.$t('listeDetailLotsComptable.tab.isValid'),
          lot: this.$t('listeDetailLotsComptable.tab.lot'),
          visu: '',
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: texts,
        childRow: Ecriture,
        columnsClasses: {
          visu: 'colonneSelected',
        },
        sortable: ['dateComptable', 'libelle', 'journal', 'isValid'],
      };
    },
    columns() {
      return ['dateComptable', 'libelle', 'journal', 'lot', 'isValid', 'visu'];
    },
    dataStep() {
      return this.listeEtat.map(el => el.libelle);
    },
    curentStep() {
      const index = this.listeEtat.map(el => el.code).indexOf(this.detailLot.etat);
      return this.dataStep[index];
    },
    getMontant() {
      let montant = 0;
      this.listeEcriture.forEach((ecriture) => {
        montant += ecriture.totalTtcPiece;
      });
      return montant;
    },
  },
  components: {
    dropdownButton,
    AppBreadcrumb: breadcrumb,
    DotSteps,
    routerLinkBlank,
    errorMsgComponent,
    popUpPrevention,
  },
  methods: {
    recherche() {
      this.listeEcriture = this.detailLot.ifEcritures
        .filter(el => el.libelle.toLowerCase().includes(this.search));
    },
    async charger() {
      this.detailLot = (await get(this.$route.params.id)).data.result;
      this.listeEcriture = this.detailLot.ifEcritures;
    },
    async transfere(tasser) {
      this.error = false;
      this.messages = [];
      const loadingComponent = this.$buefy.loading.open();
      try {
        const response = await transfere([this.detailLot.id], tasser);
        if (response.status === 206) {
          const msg = this.$i18n.t('listeDetailLotsComptable.msgSuccess.nbrLot');
          messageSucces(response.data.result ? response.data.result : 0 + ' ' + msg);
        }
        if (response.status === 200) {
          const file = new File(
            [response.data], '',
            { type: response.request.getResponseHeader('Content-Type') },
          );
          const link = this.$refs.lienDownload;
          link.href = window.URL.createObjectURL(file);
          const disposition = response.request.getResponseHeader('Content-Disposition');
          link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
          link.click();
          const msg = this.$i18n.t('listeDetailLotsComptable.msgSuccess.fileTransmis');
          messageSucces(msg);
        }
        await this.charger();
        loadingComponent.close();
      } catch (e) {
        if (e.response && e.response.data.error.validationErrors) {
          validation(e.response, this.messages);
          this.error = true;
        } else messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
    goPage(journal) {
      switch (journal.typeEcriture) {
        case TYPE_VENTE:
          return { name: 'c.bodac.factures', params: { id: journal.referencePiece } };
        case TYPE_REGLEMENT:
          return { name: 'c.bodac.remises_bancaires', params: { id: journal.referencePiece } };
        case TYPE_OD:
          return { name: 'c.comptabilite.operation_diverse', params: { id: journal.referencePiece } };
        default:
          return null;
      }
    },
    async annulerTransfert() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await annulerTransmission(this.detailLot.id);
        this.openPopUpAnnulation = false;
        messageSucces(this.$t('listeDetailLotsComptable.msgSuccess.annulation'));
        await this.charger();
      } catch (e) {
        messageErreur(this.$i18n);
        throw (e);
      } finally {
        loadingComponent.close();
      }
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.charger();
      this.setInformationPage(this.$t('pageGeneral.detail', { item: this.detailLot.libelle }));
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw (e);
    }
  },
};

</script>
